<template>
  <div id="app">
    <!--引入头部-->
    <!--<Header/>-->
    <!-- <home></home> -->
    <!--内容-->
    <!--<AppIndex/>-->

    <!--关于我们详情-->
    <!--<AboutDetail/>-->
    <!--案例展示详情-->
    <!--<CaseDetail/>-->

    <!--解决方案详情-->
    <!--<SchemeDetail/>-->
    <!--路由入口-->
    <keep-alive>
      <router-view :key="key"></router-view>
    </keep-alive>
  </div>
</template>
<script>
import Header from "@/app/common/header/app-header.vue";
// import Footer from '@/app/common/footer/app-footer.vue'
// import FloatBtn from '@/app/common/float-btn/app-float.vue'
//    import AppIndex from './app/common/index/index.vue'
//    import AboutDetail from './app/about-detail/about-detail.vue'
//    import CaseDetail from './app/case-detail/case-detail.vue'
//    import SchemeDetail from './app/scheme-detail/scheme-detail.vue'
// import Home from '@/app/common/home/Home.vue'

export default {
    name: "app",
    data() {
        return {
        };
    },
    components: {
        Header
        // Footer,
        // FloatBtn,
        // AppIndex,
        // AboutDetail,
        // CaseDetail,
        // SchemeDetail,
    },
    computed: {
        key() {
        return this.$route.name !== undefined
            ? this.$route.name + +new Date()
            : this.$route + +new Date();
        }
    }
    };
</script>
<style>
#app{
  overflow: hidden;
}

</style>
